// extracted by mini-css-extract-plugin
export default {"browserWarningMessage":"browser-warning-message__browser-warning-message__PZYK9","showAndHide":"browser-warning-message__showAndHide__Ghawn"};